import React from 'react';
import ImageTag from '../../../../../shared/ImageTag/ImageTag';
import { PRIVACY_POLICY_LINK, CCPA_LINK } from '../constants';
import './DataCenterWorldFooterLegal.scss';

interface DataCenterWorldFooterLegalProps {
  termsHref: string;
}

export default function DataCenterWorldFooterLegal({
  termsHref,
}: DataCenterWorldFooterLegalProps) {
  return (
    <div className="c-dcw-footer-legal" data-testid="dcw-footer-legal">
      <a
        href="https://www.informa.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="c-dcw-footer-legal__logo"
      >
        <ImageTag
          src="/images/informa-global.png"
          alt="Informa"
          lazy={false}
          imgixParams="h=40"
        />
      </a>
      <ul className="c-dcw-footer-legal__menu">
        <li>
          <a
            href={PRIVACY_POLICY_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
        </li>
        <li>
          <a href={termsHref} target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </li>
        <li>
          <a href={CCPA_LINK} target="_blank" rel="noopener noreferrer">
            CCPA: Do not sell my personal info
          </a>
        </li>
      </ul>
    </div>
  );
}
